export default {
  body: '<path d="M0.5 8.95624L26.2365 26.0937L49.5 0L0.5 8.95624Z" fill="#810F8C"/>',
  width: 50,
  height: 27,
};
